<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

    <the-customizer
      v-if                    = "!disableCustomizer"
      :footerType             = "footerType"
      :hideScrollToTop        = "hideScrollToTop"
      :navbarType             = "navbarType"
      :navbarColor            = "navbarColor"
      :routerTransition       = "routerTransition"
      @toggleHideScrollToTop  = "toggleHideScrollToTop"
      @updateFooter           = "updateFooter"
      @updateNavbar           = "updateNavbar"
      @updateNavbarColor      = "updateNavbarColor"
      @updateRouterTransition = "updateRouterTransition" />

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      :logo         = "navMenuLogo"
      title         = "TransVie PDV"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :logo         = "navMenuLogo"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
// import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheCustomizer       from '@/layouts/components/customizer/TheCustomizer.vue'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour
  },
  data () {
    return {
      disableCustomizer : themeConfig.disableCustomizer,
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuLogo       : require('@/assets/images/logo/logo.png'),
      // navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [
        {
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.customizer-btn',
          content : 'Customize template based on your preference',
          params  : {
            placement: 'left'
          }
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        }
      ]
    }
  },
  watch: {
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    navMenuItems () {
      const user_role = JSON.parse(localStorage.getItem('userInfo')).role

      const dashboard = {
        url: '/dashboard',
        name: 'Dashboard',
        slug: 'dashboard',
        icon: 'HomeIcon',
        i18n: 'Dashboard'
      } 
      const Utilisateurs = {
        url: '/Utilisateurs',
        name: 'Utilisateurs',
        icon: 'UsersIcon',
        slug: 'Utilisateurs',
        i18n: 'Utilisateurs'
      }
      const ressources_medicales = {
        icon: 'BriefcaseIcon',
        slug: 'Ressources médicales',
        i18n: 'ressources_medicales',
        submenu: [
          {
            url: '/actes',
            name: 'Actes',
            icon: 'FilePlusIcon',
            slug: 'actes',
            i18n: 'actes'
          },
          {
            url: '/acteTypes',
            name: 'ActeTypes',
            icon: 'FileIcon',
            slug: 'acteTypes',
            i18n: 'acteTypes'
          },
          {
            url: '/healthFacilities',
            name: 'HealthFacilities',
            icon: 'FolderPlusIcon',
            slug: 'healthFacilities',
            i18n: 'healthFacilities'
          }
        ]
      }
      const parameters = {
        icon: 'SettingsIcon',
        slug: 'Parameters',
        i18n: 'parameters',
        submenu: [
          {
            url: '/Countries',
            name: 'Countries',
            icon: 'FlagIcon',
            slug: 'Countries',
            i18n: 'countries'
          },
          {
            url: '/Regions',
            name: 'Regions',
            icon: 'MapIcon',
            slug: 'Regions',
            i18n: 'regions'
          },
          {
            url: '/Branches',
            name: 'Branches',
            icon: 'AwardIcon',
            slug: 'Branches',
            i18n: 'branches'
          },
          {
            url: '/Corporates',
            name: 'Corporates',
            icon: 'GlobeIcon',
            slug: 'Corporates',
            i18n: 'corporates'
          }
          /*  {
            url: '/Cards',
            name: 'Cards',
            icon: 'CreditCardIcon',
            slug: 'Cards',
            i18n: 'cards'
          },
          {
            url: '/healthFacilities',
            name: 'HealthFacilities',
            icon: 'FolderPlusIcon',
            slug: 'healthFacilities',
            i18n: 'healthFacilities'
          },
          {
            url: '/actes',
            name: 'Actes',
            icon: 'FilePlusIcon',
            slug: 'actes',
            i18n: 'actes'
          },
          {
            url: '/acteTypes',
            name: 'ActeTypes',
            icon: 'FileIcon',
            slug: 'acteTypes',
            i18n: 'acteTypes'
          } */
        ]
      }
      const Inscrits = {
        url: '/Inscrits',
        name: 'Inscrits',
        icon: 'ClipboardIcon',
        slug: 'Inscrits',
        i18n: 'Inscrits'
      }
      /* const Agents = {
        url: '/Agents',
        name: 'Agents',
        icon: 'UserPlusIcon',
        slug: 'Agents',
        i18n: 'Agents'
      } */
      /* const PasswordReset = {
        url: '/PasswordReset',
        name: 'PasswordReset',
        icon: 'ToolIcon',
        slug: 'PasswordReset',
        i18n: 'PasswordReset'
      } */
      /*  const Localities = {
        url: '/Localities',
        name: 'Localities',
        icon: 'GlobeIcon',
        slug: 'Localities',
        i18n: 'Localities'
      } */

      /* const Countries = {
        url: '/Countries',
        name: 'Countries',
        icon: 'FlagIcon',
        slug: 'Countries',
        i18n: 'countries'
      } 

      const Regions = {
        url: '/Regions',
        name: 'Regions',
        icon: 'MapIcon',
        slug: 'Regions',
        i18n: 'regions'
      } 
      const Branches = {
        url: '/Branches',
        name: 'Branches',
        icon: 'AwardIcon',
        slug: 'Branches',
        i18n: 'branches'
      } 

      const Corporates = {
        url: '/Corporates',
        name: 'Corporates',
        icon: 'GlobeIcon',
        slug: 'Corporates',
        i18n: 'corporates'
      }  */

      const Cards = {
        url: '/Cards',
        name: 'Cards',
        icon: 'CreditCardIcon',
        slug: 'Cards',
        i18n: 'cards'
      } 

      /* const healthFacilities = {
        url: '/healthFacilities',
        name: 'HealthFacilities',
        icon: 'FolderPlusIcon',
        slug: 'healthFacilities',
        i18n: 'healthFacilities'
      } 

      const actes = {
        url: '/actes',
        name: 'Actes',
        icon: 'FilePlusIcon',
        slug: 'actes',
        i18n: 'actes'
      }

      const acteTypes = {
        url: '/acteTypes',
        name: 'ActeTypes',
        icon: 'FileIcon',
        slug: 'acteTypes',
        i18n: 'acteTypes'
      } */

      const letters = {
        url: '/letters',
        name: 'Letters',
        icon: 'FileTextIcon',
        slug: 'letters',
        i18n: 'letters'
      }
      let role = []

      //const role_accountant = [calendar]
      const role_adminMoozi = [dashboard, letters, Cards, Inscrits,  ressources_medicales, parameters, Utilisateurs]
      const role_admin = [dashboard, letters, Cards, Inscrits, ressources_medicales, parameters, Utilisateurs]
      const role_managerClient = [dashboard, letters, Cards, Inscrits, Utilisateurs]
      const role_adminClient = [dashboard, letters, Cards, Inscrits, Utilisateurs]
      const role_manager = [dashboard, letters, Cards, Inscrits, Utilisateurs]
      const role_agent = [dashboard, letters, Inscrits, Cards]
      
      if (user_role === 'adminMoozi') {
        role = role_adminMoozi
      }
      if (user_role === 'admin') {
        role = role_admin
      }
      if (user_role === 'adminClient') {
        role = role_adminClient
      }
      if (user_role === 'managerClient') {
        role = role_managerClient
      }
      if (user_role === 'manager') {
        role = role_manager
      }
      if (user_role === 'agent') {
        role = role_agent
      }
      return role
    },
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbar (val) {
      if (val === 'static') this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff')
      this.navbarType = val
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter (val) {
      this.footerType = val
    },
    updateRouterTransition (val) {
      this.routerTransition = val
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop (val) {
      this.hideScrollToTop = val
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch('$store.state.windowWidth', (val) => {
      if (val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch('$store.state.verticalNavMenuWidth', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })
  },
  beforeDestroy () {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  }
}

</script>

